import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import {
	Form,
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";

function ResetPasswordDialog({
	form,
	onSubmit,
	showResetPasswordDialog,
	setShowResetPasswordDialog,
}: {
	form: UseFormReturn<{ email: string; otpCode: string; password: string }>;
	onSubmit: (data: {
		email: string;
		otpCode: string;
		password: string;
	}) => Promise<void>;
	showResetPasswordDialog: boolean;
	setShowResetPasswordDialog: (open: boolean) => void;
}) {
	return (
		<Dialog
			open={showResetPasswordDialog}
			onOpenChange={setShowResetPasswordDialog}
		>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Reset your password?</DialogTitle>
				</DialogHeader>
				<Form {...form}>
					<form
						onSubmit={form.handleSubmit(onSubmit)}
						className="flex flex-col gap-3"
					>
						<div className="hidden">
							<FormField
								control={form.control}
								name="email"
								render={({ field }) => (
									<FormItem>
										<FormLabel>Email</FormLabel>
										<FormControl>
											<Input
												{...field}
												required
												type={"email"}
												disabled
												className="bg-light-input"
											/>
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/>
						</div>

						<FormField
							control={form.control}
							name="otpCode"
							render={({ field }) => (
								<FormItem>
									<FormDescription>
										Please enter the one-time password sent to your email.
									</FormDescription>
									<FormControl>
										<Input
											{...field}
											required
											placeholder="OTP Code"
											className="bg-light-input"
										/>
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>

						<FormField
							control={form.control}
							name="password"
							render={({ field }) => (
								<FormItem>
									<FormLabel>Password</FormLabel>

									<FormControl>
										<Input
											{...field}
											required
											type={"password"}
											placeholder="Enter new password"
											className="bg-light-input"
										/>
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>

						<DialogFooter>
							<Button type="submit" className="mt-4 w-75">
								Reset
							</Button>
						</DialogFooter>
					</form>
				</Form>
			</DialogContent>
		</Dialog>
	);
}

export default ResetPasswordDialog;
